/**
 * Format large numbers with abbreviations (K, M, B, T)
 * @param num - The number to format
 * @param decimals - Number of decimal places (default: 1)
 * @returns Formatted string like "1.2M", "100K", "5.3B"
 */
export function formatLargeNumber(num: number | null | undefined, decimals: number = 1): string {
  if (num === null || num === undefined) {
    return 'N/A';
  }

  const absNum = Math.abs(num);
  
  if (absNum >= 1e12) {
    return (num / 1e12).toFixed(decimals) + 'T';
  } else if (absNum >= 1e9) {
    return (num / 1e9).toFixed(decimals) + 'B';
  } else if (absNum >= 1e6) {
    return (num / 1e6).toFixed(decimals) + 'M';
  } else if (absNum >= 1e3) {
    return (num / 1e3).toFixed(decimals) + 'K';
  } else {
    return num.toLocaleString();
  }
}
